import React from 'react';

import { useTranslationMessages } from '@packs/layouts/AppLayer/context';

export const I18n = ({ text: { id, defaultMessage }, variables = {} }) => {
  const { formatMessage } = useTranslationMessages();
  return <>{formatMessage({ id, defaultMessage }, variables)}</>;
};
